import type { apiClient } from '~/shared/api/data-ingestion-api'
import type { AuditTrailEventDescriptionField, PayorChangeEventProps } from '../../model'
import { collectFieldSearchText } from './searchable-text-utils'

const NO_DATA_PLACEHOLDER = '--'

/**
 * Returns null when the event should be filtered out (opti payor change events).
 */
export function transformPayorChange(
  event: apiClient.AuditEvent,
  payors: apiClient.Payor[],
  isEob?: boolean,
): PayorChangeEventProps | null {
  // Don't show payor change event for opti events
  if (!event.user) {
    return null
  }

  const prevPayor = payors.find((p) => p.payorId === event.prev_payor_id)
  const newPayor = payors.find((p) => p.payorId === event.new_payor_id)
  let fields: AuditTrailEventDescriptionField[] | null = null
  if (prevPayor || newPayor) {
    fields = [
      {
        label: 'Payor',
        values: [
          {
            previous: prevPayor
              ? `${prevPayor.payorId} ${prevPayor.payorName}`
              : NO_DATA_PLACEHOLDER,
            current: newPayor ? `${newPayor.payorId} ${newPayor.payorName}` : NO_DATA_PLACEHOLDER,
          },
        ],
      },
    ]
  }

  return {
    type: 'payor-change',
    timestamp: event.timestamp,
    user: event.user,
    userRole: 'person',
    step: isEob ? 'eob-payment-deposit' : 'data',
    ...(isEob && { visibleInSteps: ['eob-payment-deposit', 'eob-processing'] as const }),
    eventType: event.event_type,
    title: isEob ? 'Payment Deposit: Payor changed' : 'Data Extraction: Payor changed',
    fields,
  }
}

export function getPayorChangeSearchableText(props: PayorChangeEventProps): string {
  const parts = [props.title]
  if (props.fields) parts.push(collectFieldSearchText(props.fields))
  return parts.join(' ')
}
